const commonAndMisc = {
  errorMessage404: "Ups! Halaman yang Anda cari tidak ada", // translated 
  errorContentUnavailable:
    "Ups! Konten yang Anda cari tidak ada. Silakan hubungi kami tentang masalahnya", // translated 
  backToHome: "Kembali ke rumah", // translated 
  information: "Informasi", // translated 
  additionalInformation: "informasi tambahan", // translated 
  destinationPlaceholder: "Kemana kamu pergi", // translated 
  aboutUs: "Tentang kami", // translated 
  pleaseWait: "Harap tunggu...", // translated 
  featuredHotels: "Hotel Unggulan", // translated 
  topPackages: "Paket Teratas", // translated 
  topTours: "Tur Teratas", // translated 
  traveller: "Wisatawan", // translated 
  reviews: "Ulasan", // translated 
  home: "Rumah", // translated 
  packages: "Paket", // translated 
  experiences: "Pengalaman", // translated 
  close: "Menutup", // translated 
  loadingMessage: "Harap tunggu sementara kami mencari harga terbaik yang tersedia", // translated 
  loadingMessageTheHotelCo:
    "Harap tunggu sementara kami mencari harga terbaik yang tersedia", // translated 
  loadingMessageSearchStrip:
    "Harap tunggu sementara kami mencari harga terbaik yang tersedia...", // translated 
  topCountriesToVisit: "Negara Teratas untuk Dikunjungi", // translated 
  profile: "Profil", // translated 
  reservations: "Reservasi", // translated 
  myBookings: "Pemesanan Saya", // translated 
  address: "Alamat", // translated 
  firstName: "Nama depan", // translated 
  lastName: "Nama keluarga", // translated 
  email: "Surel", // translated 
  login: "Gabung", // translated 
  logout: "Keluar", // translated 
  myProfile: "Profil saya", // translated 
  myAccount: "Akun saya", // translated 
  myPoints: "Poin saya", // translated 
  myQuotations: "Kutipan Saya", // translated
  myChatRooms: "Obrolan Saya", // translated 
  chatRoomsListEmpty: "Anda tidak memiliki ruang obrolan untuk akun ini.", // translated 
  chatRoomsOpen: "Membuka", // translated 
  chatRoomsLastActivity: "Aktivitas terakhir", // translated 
  chatRoomsUnread: "Belum dibaca", // translated 
  chatRoomsBadgeQuotation: "Penawaran", // translated 
  chatRoomsBadgeTripOffer: "Penawaran perjalanan", // translated 
  chatRoomsOpenQuotationAria: "Buka obrolan penawaran: {{name}}", // translated 
  chatRoomsOpenTripOfferAria: "Obrolan penawaran perjalanan terbuka: {{name}}", // translated 
  chatRoomsOpenGenericAria: "Buka obrolan: {{name}}", // translated 
  quotationChatInvalidLink:
    "Percakapan dialog tidak valid. Buka percakapan dari profil atau daftar penawaran Anda, atau gunakan tepat satu dari room_code atau room_uid.", // translated 
  quotationChatNoTripDetails: "Detail perjalanan tidak tersedia untuk diskusi ini.", // translated 
  chat: "Mengobrol", // translated 
  verified: "Diverifikasi", // translated 
  unverified: "Tidak diverifikasi", // translated 
  selectLanguage: "Pilih bahasa", // translated 
  selectCurrency: "Pilih Mata Uang", // translated 
  upgrade: "Meningkatkan", // translated 
  membership: "Keanggotaan", // translated 
  travelTrust: "Kepercayaan Perjalanan", // translated 
  signInUp: "Masuk/Naik", // translated 
  worldwideHotelsAndResortsAtAmazingWholesaleRates:
    "hotel dan resor di seluruh dunia dengan harga grosir yang luar biasa", // translated 
  dashboard: "Dasbor", // translated 
  pricing: "Harga", // translated 
  refundable: "Dapat dikembalikan", // translated 
  cars: "Mobil", // translated 
  cruises: "kapal pesiar", // translated 
  view: "Melihat", // translated 
  price: "Harga", // translated 
  totalPrice: "Total harga", // translated 
  filterRoomName: "Filter nama ruangan", // translated 
  get: "Mendapatkan", // translated 
  guestInformationValidation: "Validasi Informasi Tamu", // translated 
  reservation: "Reservasi", // translated 
  checkIn: "Mendaftar", // translated 
  checkOut: "Periksa", // translated 
  paymentInitiattionErroeMessage:
    "Kami tidak dapat memulai proses pembayaran Anda. Kami mohon maaf atas ketidaknyamanan ini", // translated 
  warning: "Peringatan", // translated 
  couldNotFindPriceForDateWarning:
    "Kami tidak dapat menemukan harga untuk tanggal ini. Silakan coba lagi untuk tanggal yang berbeda", // translated 
  searchFormValidationError: "Kesalahan Validasi Formulir Pencarian", // translated 
  pleaseSelectValidDateFirst: "Silakan pilih tanggal yang valid terlebih dahulu", // translated 
  searchError: "Kesalahan Pencarian", // translated 
  priceSearchInitiationError:
    "Kami tidak dapat memulai proses pencarian harga. Silakan coba lagi nanti. Kami mohon maaf atas ketidaknyamanan ini", // translated 
  searchWarning: "Peringatan Pencarian", // translated 
  couldNotFindPriceAndOrAvailability:
    "Kami tidak dapat menemukan harga dan/atau ketersediaan untuk permintaan Anda. Kami mohon maaf atas ketidaknyamanan ini", // translated 
  joinNow: " Bergabung sekarang", // translated 
  signIn: "Masuk", // translated 
  searchNow: "Cari sekarang", // translated 
  bookingFailed: "Pemesanan gagal", // translated 
  sorryForTheInconvenience: "Kami mohon maaf atas ketidaknyamanan ini", // translated 
  contactUsToAssistWithYourBooking:
    "Silakan hubungi kami untuk membantu pemesanan Anda. Kami mohon maaf atas ketidaknyamanan ini", // translated 
  paymentFailedTryAgain: "Pembayaran gagal. Silakan coba lagi", // translated 
  quickLinks: "tautan langsung", // translated 
  tours: "Tur", // translated 
  termsAndConditions: "syarat dan Ketentuan", // translated 
  pleaseWaitWhileInitiatingPayment:
    "Harap tunggu sementara kami memulai proses pembayaran Anda", // translated 
  back: "Kembali", // translated 
  nextStep: "Langkah berikutnya", // translated 
  book: "Buku", // translated 
  checkout: "Periksa", // translated 
  specifyPickUpPoint: " Tentukan titik penjemputan pilihan Anda", // translated 
  pickupPoint: "Titik Penjemputan", // translated 
  optional: "opsional", // translated 
  provideImportantInfoForYourTravel:
    "Beri tahu kami informasi apa pun yang penting selama perjalanan Anda", // translated 
  remarks: "Perkataan", // translated 
  travellerInformation: "Informasi Wisatawan", // translated 
  bookingRemarks: "Keterangan Pemesanan", // translated 
  bookingOverview: "Ikhtisar Pemesanan", // translated 
  paymentFailed: "Pembayaran gagal", // translated 
  paymentSuccess: "pembayaran berhasil", // translated 
  at: "Pada", // At date // translated 
  on: "Pada", // on date // translated 
  person: "orang", // translated 
  cancellationPolicy: "Kebijakan Pembatalan", // translated 
  From: "Dari", // translated 
  to: "Ke", // translated 
  cancellationIs: "pembatalan adalah", // translated 
  pickup: "Menjemput", // translated 
  flights: "Penerbangan", // translated 
  Accommodation: "Akomodasi", // translated 
  payAndBook: "Bayar & Pesan", // translated 
  onRequest: "Dalam permintaan", // translated 
  weAreFindingTheBestAvailableServices:
    "Kami menemukan layanan terbaik yang tersedia", // translated 
  withTheBestAvailablePrices: "dengan harga terbaik yang tersedia", // translated 
  inRealTime: "dalam waktu nyata", // translated 
  seconds: "detik", // translated 
  thisProcessCanTakeUpToOneMinute: "Proses ini dapat memakan waktu hingga 1 menit", // translated 
  pleaseDoNotRefreshThisPage: "Mohon jangan segarkan halaman ini", // translated 
  wellItSeemsItCanTakeBitLonger: "Yah... sepertinya ini akan memakan waktu lebih lama", // translated 
  yourBrowserDoesNotSupportTheVideoTag:
    "Browser Anda tidak mendukung tag video", // translated 
  bookingSuccess: "Pemesanan berhasil", // translated 
  bookingReference: "Referensi pemesanan", // translated 
  referenceCopied: "Referensi disalin", // translated 
  shortlyYouReceiveEmailContainingInformationForYourReservation:
    "Sebentar lagi, Anda akan menerima email berisi semua informasi yang diperlukan untuk reservasi Anda", // translated 
  viewMore: "Lihat lebih banyak", // translated 
  readMore: "Baca selengkapnya", // translated 
  customerSupport: "Dukungan Pelanggan", // translated 
  socialMedia: "Media sosial", // translated 
  hours: "jam", // translated 
  hour: "jam", // translated 
  minutes: "menit", // translated 
  minute: "menit", // translated 
  memberId: "Tanda Anggota", // translated 
  star: "Bintang", // translated 
  stars: "Bintang", // translated 
  proceed: "Melanjutkan", // translated 
  clearAllFilters: "Hapus semua filter", // translated 
  clearYourFilters: "Harap hapus opsi filter Anda untuk melihat hasilnya", // translated 
  noOptionsForSelectedFilters: "Tidak ada opsi yang tersedia untuk mencocokkan filter Anda", // translated 
  privacyPolicy: "Kebijakan pribadi", // translated 
  security: "Keamanan", // translated 
  nearby: "Di dekat sini", // translated 
  distanceFromSelection: "Jarak dari seleksi", // translated 
  km: "km", // translated 
  restaurants: "Restoran", // translated 
  active: "Aktif", // translated 
  visitSite: "Mengunjungi situs", // translated 
  score: "Skor", // translated 
  applicationAvailable: "aplikasi tersedia", // translated 
  sendUsEmail: "Kirimi kami Email", // translated 
  sendUsYourRequest: "Kirimkan permintaan Anda kepada kami", // translated 
  notAvailable: "Tidak tersedia", // translated 
  found: "Ditemukan", // translated 
  progressAt: "Kemajuan di", // translated 
  currency: "Mata uang", // translated 
  sendUsRequest: "Kirimkan permintaan Anda kepada kami", // translated 
  noReservationsForThisProduct: "Tidak ada reservasi untuk produk ini", // translated 
  noBookingsForThisProduct: "Tidak ada pemesanan untuk produk ini", // translated 
  confirmed: "Dikonfirmasi", // translated 
  cancelled: "Dibatalkan", // translated 
  pending: "Tertunda", // translated 
  notConfirmed: "Tidak Dikonfirmasi", // translated 
  status: "Status", // translated  // translated 
  reference: "Referensi", // translated 
  leadGuest: "Tamu Utama", // translated 
  sendVoucherEmail: "Kirim Email Voucher", // translated 
  sendCancellationEmail: "Kirim Email Pembatalan", // translated 
  downloadVoucher: "Unduh Voucher", // translated 
  emailHasBeenSent: "Email berhasil terkirim", // translated 
  emailNotSentTryAgain: "Email tidak terkirim! Silakan coba lagi", // translated 
  titleIsRequired: "Judul diperlukan", // translated 
  genderIsRequired: "Jenis kelamin diperlukan", // translated 
  firstNameMustContainAlphabetic:
    "Nama depan hanya boleh berisi karakter alfabet", // translated 
  firstNameIsRequired: "Nama depan wajib diisi", // translated 
  lastNameIsRequired: "Nama belakang wajib diisi", // translated 
  lastNameMustContainAlphabetic:
    "Nama belakang hanya boleh berisi karakter alfabet", // translated 
  phoneNumberInTheFormat: "Nomor telepon harus dalam format tanpa spasi", // translated 
  phoneNumberIsRequired: "Nomor telepon diperlukan", // translated 
  emailIsRequired: "Email diperlukan", // translated 
  invalidEmail: "Email tidak valid", // translated 
  addressIsRequired: "alamat diperlukan", // translated 
  cityIsRequired: "Kota diperlukan", // translated 
  postalCodeIsRequired: "Kode pos diperlukan", // translated 
  countryIsRequired: "Negara diperlukan", // translated 
  yourReservationIsInProgress: "Reservasi Anda sedang diproses", // translated 
  yourReservationHasBeenRegistered: "Reservasi Anda telah terdaftar", // translated 
  clickHere: "klik disini", // translated 
  iHaveReadAgreeWithAbove: "Saya telah membaca dan setuju dengan hal di atas", // translated 
  pleaseCheckTheBox:
    "Silakan centang kotak di bagian bawah untuk menunjukkan bahwa Anda telah membaca dan menyetujui informasi yang diberikan sebelum melanjutkan ke langkah berikutnya.", // translated 
  pleaseAcceptProperty:
    "Silakan centang kotak di bagian atas untuk menunjukkan bahwa properti yang dipesan adalah properti yang Anda butuhkan.", // translated 
  ourContactNumbersAre: "Nomor kontak kami adalah", // translated 
  operationalHours: "Jam Operasional", // translated 
  monday: "Senin", // translated 
  tuesday: "Selasa", // translated 
  wednesday: "Rabu", // translated 
  thursday: "Kamis", // translated 
  friday: "Jumat", // translated 
  saturday: "Sabtu", // translated 
  sunday: "Minggu", // translated 
  monday_to_friday: "Senin sampai Jumat", // translated 
  closed: "Tertutup", // translated 
  topUpPoints: "Poin Isi Ulang", // translated 
  gender: "Jenis kelamin", // translated 
  nationality: "Kebangsaan", // translated 
  maintenanceTitle: "Situs sedang dalam pemeliharaan", // translated 
  maintenanceDescription:
    "Kami sedang melakukan pemeliharaan terjadwal. Silakan kembali lagi nanti.", // translated 
  maintenanceCountdownLabel: "Perkiraan waktu tersisa", // translated 
  maintenanceLogoAlt: "Logo situs web", // translated 
  maintenanceDays: "Hari", // translated 
  maintenanceHours: "Selai", // translated 
  maintenanceMinutes: "Menit", // translated 
  maintenanceSeconds: "Detik", // translated 
  maintenanceStatusBadge: "Pemeliharaan terjadwal", // translated 
  maintenanceRefresh: "Muat ulang halaman", // translated 
  maintenanceExpired:
    "Pemeliharaan seharusnya segera selesai. Silakan unduh ulang halaman.", // translated 
};



export default commonAndMisc;
